import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import CardList from '@/components/CardList.vue';
import ModalAction from '@/components/ModalAction.vue';
import axios from 'axios';
import StorageService from '@/services/StorageService';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import { BusinessType, InfoTag } from '@/models/Menu';
let Favorites = class Favorites extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.user = this.$store.state.user;
        this.menus = [];
        this.modal = false;
        this.toDelete = null;
        this.config = {
            headers: {
                Authorization: this.user.authToken,
            }
        };
    }
    async deleteFavorite() {
        try {
            const body = { ordersPlaced: 0, active: false };
            await axios.put(`${process.env.VUE_APP_FAVORITES}/${this.toDelete?.id}`, body, this.config);
            this.modal = false;
            this.$router.push('/profile');
        }
        catch (err) {
            console.log(err);
            return;
        }
    }
    get catalogs() {
        return this.menus;
    }
    hideSlide() {
        this.modal = false;
    }
    showSlide(toDelete) {
        this.toDelete = toDelete;
        this.modal = true;
    }
    async created() {
        this.loading = true;
        this.config.headers.Authorization = this.user.authToken;
        try {
            const reqFavorites = await axios.get(`${process.env.VUE_APP_FAVORITES}`, this.config);
            const catalogs = reqFavorites.data.filter(data => data.active);
            if (catalogs.length != 0) {
                const params = new URLSearchParams();
                catalogs.forEach(cat => { params.append('id', cat.id); });
                const param = { params: params };
                const reqCatalogs = await axios.get(`${process.env.VUE_APP_CATALOG}`, param);
                reqCatalogs.data.forEach(async (infBus) => {
                    const infoBusines = {
                        id: infBus.id,
                        restaurantId: infBus.restaurantId,
                        name: infBus.name,
                        description: infBus.description,
                        logo: await StorageService.getFile(infBus.logo),
                        open: infBus.open,
                        directory: {
                            businessType: infBus.directory?.businessType ? infBus.directory.businessType : BusinessType.ND,
                            infoTag: infBus.open ? infBus.directory?.infoTag : InfoTag.CLOSE,
                            businessCategory: infBus.directory?.businessCategory ? infBus.directory?.businessCategory.map(bus => bus.replace('businessTags/', '')) : ['']
                        }
                    };
                    this.menus.push(infoBusines);
                });
            }
        }
        catch (err) {
            console.log(err);
        }
        this.loading = false;
    }
};
Favorites = __decorate([
    Component({
        components: {
            CommonHeader,
            CardList,
            ModalAction,
            SpinnerHolder
        }
    })
], Favorites);
export default Favorites;
